/**
 * 🎯 HERO METRIC WIDGET (PRIMARY_INSIGHT)
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Widget para la métrica principal ejecutiva.
 * Siempre es PRIMARY, no necesita prop isPrimary.
 * 
 * REGLAS:
 * - Full width (backend manda w:12)
 * - Número 72px, cyan, bold 800
 * - Text-shadow para impacto
 * - Sin lógica de negocio
 */

import React from 'react';
import type { ExecutiveWidget } from '../types';

interface HeroMetricWidgetProps {
  widget: ExecutiveWidget;
}

const HeroMetricWidget: React.FC<HeroMetricWidgetProps> = ({ widget }) => {
  
  // Valor principal (primer elemento del array)
  const rawValue = widget.data?.[0]?.valor ?? 0;
  const value = typeof rawValue === 'number' ? rawValue : parseFloat(String(rawValue)) || 0;
  
  // Formateo según metadata
  const format = widget.metadata?.format || 'number';
  const decimals = widget.metadata?.decimals ?? 0;
  
  const formattedValue = formatValue(value, format, decimals);
  
  return (
    <div className="hero-metric-widget">
      <div className="hero-metric-value">
        {formattedValue}
      </div>
      <div className="hero-metric-label">
        {widget.title}
      </div>
    </div>
  );
};

/**
 * Formatear valor según tipo
 */
function formatValue(value: number, format: string, decimals: number): string {
  switch (format) {
    case 'currency':
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    
    case 'percentage':
      return new Intl.NumberFormat('es-AR', {
        style: 'percent',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value / 100);
    
    default:
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
  }
}

export default HeroMetricWidget;
